<template>
    <div>
        <table class="table table-report -mt-2" v-bind:class="{'deactivate-shadow': hideHead}">
            <thead v-if="!hideHead">
                <tr>
                    <th class="w-3/12"><span class="w-64 inline-block">DOCUMENTO</span></th>
                    <th class="w-1/12 text-center">FECHA DOC.</th>
                    <th class="w-1/12 text-center">CADUCIDAD</th>
                    <th class="w-2/12 text-center">ESTADO</th>
                    <th class="w-2/12 text-left">MOTIVO</th>
                    <th class="w-3/12 text-right">ACCIONES</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(file, index) in this.files" :key="index" v-bind:class="{'block': file.childs, 'hide-childs': debeOcultarHijos(file)}">
                    <td class="overflow-hidden w-3/12">
                        <div :title="file.name" class="font-medium overflow-hidden inline-block">
                            <CircleIcon v-if="!mostrar_resumen" v-for="repeat of calculateCircleDepth(file, actual_depth)" class="w-3 h-3 mr-1 inline-block text-blue-300" />
                            <span>{{file.name}}</span>
                        </div>
                    </td>
                    <td class="overflow-hidden w-1/12 text-center">
                        <span v-if="file.files[file.order]" class="font-light">{{ file.files[file.order].createdDate | str_to_time }}</span>
                        <span v-if="!file.files[file.order]" class="font-light">-</span>
                    </td>
                    <td class="overflow-hidden w-1/12 text-center">
                        <span v-if="file.files[file.order]" class="font-light">{{ file.files[file.order].fecha_caducidad | str_to_time }}</span>
                        <span v-if="!file.files[file.order]" class="font-light">-</span>
                    </td>
                    <td class="overflow-hidden w-2/12">
                        <div v-if="!file.childs" :class="{'text-theme-11': file.files[file.order] && file.files[file.order].state == '1', 'text-theme-12': file.files[file.order] && file.files[file.order].state == '3', 'text-theme-9': file.files[file.order] && file.files[file.order].state == '2', 'text-theme-6': (!file.files[file.order] || !file.files[file.order].state)}">
                            <div v-if="!file.files[file.order] || !file.files[file.order].state" class="flex items-center justify-center">
                                <ClockIcon class="w-4 h-4 mr-2" />
                                <span>Pdt. envío</span>
                            </div>
                            <div v-if="file.files[file.order] && file.files[file.order].state == '1'" class="flex items-center justify-center">
                                <EyeIcon class="w-4 h-4 mr-2" />
                                <span>En revisión</span>
                            </div>
                            <div v-if="file.files[file.order] && file.files[file.order].state == '2'" class="flex items-center justify-center">
                                <CheckSquareIcon class="w-4 h-4 mr-2" />
                                <span>Correcto</span>
                            </div>
                            <div v-if="file.files[file.order] && file.files[file.order].state == '3'" class="flex items-center justify-center">
                                <XOctagonIcon class="w-4 h-4 mr-2" />
                                <span>No presenta</span>
                            </div>
                        </div>
                        <div v-if="file.childs" class="flex items-center justify-center text-gray-600 text-xs">
                            <span>-</span>
                        </div>
                    </td>
                    <td class="overflow-hidden w-2/12">
                        <div class="text-gray-600 text-xs">
                            {{ file.files[file.order]?file.files[file.order].reason:'-' }}
                        </div>
                    </td>
                    <td v-if="!file.childs" class="overflow-hidden w-3/12 table-report__action w-56">
                        <div v-if="!isAdmin" class="flex justify-center items-center">
                            <a :href="file.files[file.order].urlForDownload" target="_blank" v-if="file.files[file.order] && file.files[file.order].state == '2'" class="flex items-center mr-3 text-gray-600">
                                <EyeIcon class="w-4 h-4 mr-1" />
                                Ver
                            </a>
                            <button v-if="file.files[file.order] && file.files[file.order].state == '1'" class="flex items-center mr-3 text-gray-600" @click="uploadFile(file)">
                                <CheckSquareIcon class="w-4 h-4 mr-1" />
                                Modificar
                            </button>
                            <button v-if="!file.files[file.order] || !file.files[file.order].state" class="flex items-center mr-3 text-theme-10" @click="uploadFile(file)">
                                <UploadIcon class="w-4 h-4 mr-1" />
                                Subir
                            </button>
                        </div>
                        <div v-if="isAdmin" class="flex flex-col justify-center items-start leading-tight py-2">
                            <a :href="file.files[file.order].urlForDownload" target="_blank" v-if="file.files[file.order]" class="whitespace-no-wrap mb-2 ml-2 flex items-center mr-3 text-gray-600">
                                <EyeIcon class="w-4 h-4 mr-1" />
                                Ver
                            </a>
                            <button class="flex mb-2 ml-2 items-center mr-3 text-theme-9 whitespace-no-wrap" v-if="file.files[file.order]" @click="aprobar(file)">
                                <CheckCircleIcon class="w-4 h-4 mr-1" />
                                Aprobar archivo
                            </button>
                            <button class="flex mb-2 ml-2 items-center mr-3 text-theme-6 whitespace-no-wrap" v-if="file.files[file.order]" @click="rechazar(file)">
                                <XCircleIcon class="w-4 h-4 mr-1" />
                                Rechazar archivo
                            </button>
                            <button class="flex ml-2 items-center mr-3 text-theme-4 whitespace-no-wrap" @click="uploadFile(file)">
                                <CheckSquareIcon class="w-4 h-4 mr-1" />
                                Modificar
                            </button>
                        </div>
                    </td>
                    <td v-if="file.childs" class="overflow-hidden w-3/12">-</td>
                    <td class="overflow-hidden w-2/12 break" v-if="file.childs">
                        <control-list :actual_depth="actual_depth" :mostrar_resumen="mostrar_resumen" :last_24h="last_24h" :solo_pendientes_revision="solo_pendientes_revision" :hide-head="true" :files="file.childs"></control-list>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<style type="text/css" scoped>
    table,
    tbody,
    thead {
      display: block;/* whatever, just  reset table layout display to go further */
    }
    tr {
      display:flex;
      flex-wrap:wrap; /* allow to wrap on multiple rows */
      margin-top: .3rem;
    }
    td, th {
      display:flex;
      justify-content: center;
      align-items: center;
      /*flex:1 /* to evenly distributs flex elements */
    }
    td > div {
        width: 100%;
    }
    .break {
        width: 100%;
        flex: auto;
        padding: 0;
        margin-top: 8px;
        background: none !important;
    }
    .break > div { width: 100%; }
    tr.hide-childs {
        margin: 0;
    }
    tr.hide-childs > td:not(.break) {
        display: none;
    }
    .table-report > tbody > tr:not(.block) td {
        /*box-shadow: 10px 10px rgba(0,0,0,.5)*/
        /*box-shadow: 20px 3px 20px #0000000b;*/
    }
</style>
<script>
export default {
    name: "control-list",
    props: ["files", "searchTerm", "limit", "order", "hideHead", "mostrar_resumen", "last_24h", "actual_depth", "solo_pendientes_revision"],
    components: {},
    data() {
        return {
            data: []
        };
    },
    filters: {
        str_to_time: function(time) {
            if(!time) return '-';
            const meses = ['Enero','Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
            let date = new Date(time);
            if(date instanceof Date && !isNaN(date)) return date.getDate() + ' ' + meses[date.getMonth()] + ' ' + date.getFullYear();
            else return '-';
        }
    },
    mounted() {
        //this.data = this.files;
    },
    watch: {},
    computed: {
        isAdmin() {
            return window.bus.admin;
        },
    },
    methods: {
        debeOcultarHijos(file) {
            if(this.solo_pendientes_revision && !file.childs) {
                if(file.files && file.files[file.order] && file.files[file.order].state === '1') return false;
                return true;
            }
            if(this.mostrar_resumen && !file.allowFileUpload) {
                return true;
            }
            if(this.last_24h && this.mostrar_resumen) {
                if(file.files[file.order] && file.files[file.order].cuantasHorasTieneElArchivo < 24) return false;
                return true;
            }
            if(this.isAdmin && (this.mostrar_resumen && !file.files[file.order]) || (this.mostrar_resumen && file.files[file.order] && file.files[file.order].state !== '' && file.files[file.order].state != "2")) {
                return false
            }
            if(!this.mostrar_resumen || !file.files[file.order] || !file.files[file.order].state) {
                return false;
            }
            return true;
        },
        uploadFile(fileTemplate) {
            let reason = '';
            if(fileTemplate.files && fileTemplate.files[fileTemplate.order] && fileTemplate.files[fileTemplate.order].reason) {
                reason = fileTemplate.files[fileTemplate.order].reason;
            }
            window.bus.$emit("modalUploadFile", {
                files: fileTemplate.files,
                fileName: fileTemplate.name,
                tableName: fileTemplate.tableName,
                fieldName: 'file',
                urlPath: '',
                filePath: '',
                recordNum: fileTemplate.recordNum,
                info1: fileTemplate.num, // Corresponde a la plantilla
                info2: 1, // Corresponde al estado.
                info3: reason, // Corresponde al motivo del estado.
                fecha_caducidad: fileTemplate.files[fileTemplate.order]?fileTemplate.files[fileTemplate.order]['fecha_caducidad']:null,
                order: fileTemplate.order, // Corresponde al índice de una repetición.
                config: {
                    rellena_fecha_caducidad: fileTemplate.fecha_caducidad
                },
                callback: (files) => {
                    if (files) {
                        fileTemplate.files = Object.keys(files).map((key) => { if (files[key] && files[key].state) files[key].state = "1"; return files[key]; });
                    } else {
                        fileTemplate.files = {};
                    }
                }
            });
        },
        aprobar(file) {
            if(!this.isAdmin || !file.files || !file.files[file.order]) return;
            console.log(file)
            let reason = prompt('Aprobar archivo con motivo:', file.files[file.order].reason);
            CmsApi.hook("/hooks/save/",{
                action: 'file', 
                data: JSON.stringify({
                    file: file.files[file.order], 
                    state: 2, 
                    reason: reason,
                    fecha_caducidad: file.files[file.order].fecha_caducidad,
                    owner: this.$d().user.centro_empresa_elegido
                })},(data) => {
                        if (data.success) {
                            window.bus.$emit('reloadDataFromServer');
                        }
                    });
        },
        rechazar(file) {
            if(!this.isAdmin || !file.files || !file.files[file.order]) return;
            console.log(file)
            let reason = prompt('Rechazar archivo con motivo:', 'Archivo incorrecto');
            if(reason) {
                CmsApi.hook("/hooks/save/",{
                    action: 'file', 
                    data: JSON.stringify({
                        file: file.files[file.order], 
                        state: '', 
                        reason: reason,
                        fecha_caducidad: file.files[file.order].fecha_caducidad,
                        owner: this.$d().user.centro_empresa_elegido
                    })},(data) => {
                        if (data.success) {
                            window.bus.$emit('reloadDataFromServer');
                        }
                    });
            }
        }
    }
};
</script>